import { applyLocalizedPwaMetadata } from '../services/PwaMetadataService';

export const DEFAULT_LANGUAGE = 'en';

export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'ko', label: '한국어' },
];

const LANGUAGE_STORAGE_KEY = 'app_language';
const supportedLanguageCodes = new Set(SUPPORTED_LANGUAGES.map((language) => language.code));

export function detectBrowserLanguage(navigatorValue = typeof navigator !== 'undefined' ? navigator : null) {
  const browserLocale = navigatorValue?.language || navigatorValue?.languages?.[0] || '';
  const primaryLanguage = String(browserLocale).trim().toLowerCase().split(/[-_]/)[0];
  return supportedLanguageCodes.has(primaryLanguage) ? primaryLanguage : DEFAULT_LANGUAGE;
}

export function normalizeLanguage(value) {
  const code = String(value || '').trim().toLowerCase();
  return supportedLanguageCodes.has(code) ? code : DEFAULT_LANGUAGE;
}

export function getLanguage() {
  if (typeof localStorage === 'undefined') return detectBrowserLanguage();
  const storedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  return storedLanguage ? normalizeLanguage(storedLanguage) : detectBrowserLanguage();
}

export function setLanguage(value) {
  const language = normalizeLanguage(value);
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  }
  if (typeof window !== 'undefined') {
    applyLocalizedPwaMetadata(language);
    window.dispatchEvent(new CustomEvent('appLanguageChanged', { detail: { language } }));
  }
  return language;
}

export function getLanguageLabel(value) {
  const language = SUPPORTED_LANGUAGES.find((entry) => entry.code === normalizeLanguage(value));
  return language?.label || SUPPORTED_LANGUAGES[0].label;
}
